/**
 * QRMaps Design System - Sidebar Styled Components
 *
 * Reusable sidebar components for sidebars like MapListBar, MapEditBar, etc.
 */

import styled from 'styled-components';

export const SidebarContainer = styled.div`
  z-index: ${({ theme }) => theme.zIndex.sidebar};
  width: ${({ $isMobile, $sidebarWidth }) =>
    $isMobile ? '100%' : ($sidebarWidth || '400px')};
  height: ${({ $isMobile, $dragHeight, $sidebarHeight }) =>
    $isMobile ? ($dragHeight || 'auto') : ($sidebarHeight || '100vh')};
  max-height: ${({ $isMobile }) => $isMobile ? '90vh' : '100vh'};
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: ${({ $isMobile, $position }) =>
    $isMobile ? 0 : ($position === 'left' ? 'auto' : 'auto')};
  right: ${({ $position }) => $position === 'right' || !$position ? 0 : 'auto'};
  left: ${({ $isMobile, $position }) =>
    $isMobile ? 0 : ($position === 'left' ? 0 : 'auto')};
  top: ${({ $isMobile }) => $isMobile ? 'auto' : 0};
  background: ${({ theme }) => theme.colors.neutral[0]};
  box-shadow: ${({ $isMobile, theme }) =>
    $isMobile ? `0 -2px 10px ${theme.colors.shadow.normal}` : 'none'};
  border-radius: ${({ $isMobile }) => $isMobile ? '10px 10px 0 0' : '0'};
  overflow: hidden;
`;

// Drag handle (chevron) - mobile only
export const SidebarDragHandle = styled.button`
  position: absolute;
  right: 50%;
  top: -15px;
  transform: translateX(50%);
  background: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  height: 20px;
  width: 15vw;
  border-radius: ${({ theme }) => theme.spacing[1]} ${({ theme }) => theme.spacing[1]} 0 0;
  padding: 0;
  z-index: ${({ theme }) => theme.zIndex.sidebar + 1};
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ns-resize;
  touch-action: none;
  user-select: none;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[100]};
  }

  &:active {
    background: ${({ theme }) => theme.colors.neutral[200]};
  }
`;

// Close button (cross) - both mobile and desktop
export const SidebarCloseButton = styled.button`
  position: absolute;
  right: ${({ $isMobile }) => $isMobile ? '10px' : 'auto'};
  left: ${({ $isMobile }) => $isMobile ? 'auto' : '-15px'};
  top: ${({ $isMobile }) => $isMobile ? '-15px' : '10px'};
  background: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 0;
  z-index: ${({ theme }) => theme.zIndex.sidebarControls};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[100]};
  }

  &:active {
    background: ${({ theme }) => theme.colors.neutral[200]};
  }
`;

export const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ theme }) => theme.spacing[4]};
  min-height: 0;
  max-height: ${({ $isMobile }) => $isMobile ? 'calc(50vh - 250px)' : 'none'};
`;

export const SidebarHeader = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.neutral[0]};
`;

export const SidebarFooter = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  display: flex;
  justify-content: space-around;
  background: ${({ theme }) => theme.colors.neutral[50]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  margin-top: auto;
  position: ${({ $isMobile }) => $isMobile ? 'sticky' : 'relative'};
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndex.sidebar + 2};
`;